// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"198c0216","84":"eb8fab64","247":"4e59366f","440":"a4357f62","488":"1b671b75","627":"4a2499e4","738":"1b3528cd","834":"d5ff911f","923":"c633c34d"}[chunkId] + ".chunk.js";
};